.DettaglioContainer {
  padding: 16px;
  overflow-y: auto;
  height: 100%;
  position: relative;
}

.DettaglioContainerDesktop {
  padding: 0px;
  overflow-y: auto;
  height: 100%;
  position: relative;
  width: 100%;
}

.DettaglioInfoCardDesktop {
  background-color: inherit;
  padding: 0px;
}

.DettaglioInfoCard {
  background-color: var(--overlay);
  padding: 16px;
  border-radius: 5px;
}

.BgDisabled {
  background-color: #ffe6e3 !important;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  border-radius: 30px;
}

.BlockEnableDisable {
  border-radius: 5px;
  border: 1px solid var(--Monumenti-Senza-foto, #cf4130);
  background: #fecdc7;
  margin-top: 24px;
  padding: 16px 24px;
}

.TitlePannelloAntivandalismo {
  color: var(--Monumenti-Senza-foto, #cf4130);

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.TextPannelloAntivandalismo {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 16px;
  font-family: var(--font-roboto-slab);
}

.ButtonEnable {
  background-color: var(--colori-neutri-white);
  border-radius: 5px;
  color: var(--tertiary);
  width: 100%;
  border: none;
  padding: 8px 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
}

.ButtonDisable {
  background-color: var(--tertiary);
  border-radius: 5px;
  color: var(--colori-neutri-white);
  width: 100%;
  border: none;
  padding: 8px 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
}

.PresenzaInConcorso {
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 9px;
  align-self: stretch;
  border-radius: 5px;
  border: 1px solid var(--concorso);
  background: var(--colori-neutri-white);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  font-family: var(--font-roboto-slab);
  color: var(--primary);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 0px;
}

.BlockImage {
  border-radius: 5px;
  height: 221px;
  width: 100%;
  margin-top: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

.BlockImageRelevant {
  border-radius: 5px;
  height: 221px;
  width: 100%;
  margin-top: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.CardInfoMonument {
  border-radius: 5px;
  background: var(--colori-neutri-white);
  display: flex;
  padding: 16px 24px;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
  align-self: stretch;
}

.CardParentTitle, .CardChildrenTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--primary);
  margin-top: 8px;
  margin-bottom: 8px;
}

.MonumentCard {
  display: flex;
  min-height: 84px;
  padding: 16px 24px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  margin-bottom: 4px;
}

.MonumentTitle {
  color: var(--primary);
  overflow: hidden;
  text-overflow: ellipsis;
  /* H1 */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  max-width: max-content;
}

.Comune {
  color: var(--colori-neutri-gray);
  overflow: hidden;
  text-overflow: ellipsis;
  /* Links */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
}

.PicturesCount {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 8px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  color: var(--primary);
}

.CardImages {
  background-color: var(--overlay);
  padding: 16px;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  margin-top: 16px;
}

.ImmaginiWlmTitle {
  color: var(--colori-neutri-gray);
  text-align: center;
  /* H1 */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 32px;
  line-height: normal;
}

.Image {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

.ContainerImages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.FixedButtonUpload {
  position: fixed;
  bottom: calc(var(--bottom-mobile-navigation-height) + 30px);
  right: 16px;
  z-index: 3;
}

.ButtonUpload {
  border-radius: 48px;
  border: none;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  display: inline-flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
}

.PaginationDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--colori-neutri-gray);
  margin-right: 8px;
}

.PaginationImagesDots {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.PaginationDotActive {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--primary);
  margin-right: 8px;
}

.ButtonShowAllImages {
  margin-top: 16px;
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  border: none;
  width: 100%;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: var(--colori-neutri-gray);
}

.MapContainer {
  height: 221px;
  width: 100%;
  margin-top: 8px;
  border-radius: 5px;
  position: relative;
}

.Map {
  height: 100%;
  width: 100%;
  border-radius: 5px;
}

.GuardaInMappa {
  display: inline-flex;
  height: 28px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  position: absolute;
  bottom: 8px;
  left: 8px;
  border: none;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: var(--colori-neutri-gray);
  transition: all 0.3s ease-in-out;
}

.GuardaInMappa:hover {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  color: var(--primary);
}

.Direction {
  position: absolute;
  bottom: 8px;
  right: 8px;
  border-radius: 5px;
  background: var(--primary);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  display: flex;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.Direction:hover {
  background: var(--secondary);
}

.CardExternalLinks {
  margin-top: 16px;
  padding: 16px;
  border-radius: 5px;
  background: var(--overlay);
}

.CardMonumentiComune {
  margin-top: 16px;
  padding: 16px;
  border-radius: 5px;
  background: var(--overlay);
}

.IMonumentiDelComune {
  color: var(--primary);
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.MonumentiComune {
  margin-top: 16px;
}

.MonumentiComuneItem {
  display: flex;
  padding: 8px 8px 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  margin-bottom: 5px;
}

.MonumentiComuneItemTitle {
  color: var(--colori-neutri-dark-gray);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
}

.MonumentiComuneItemValue {
  color: var(--primary);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.ButtonShowMonumenti {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--primary);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--colori-neutri-white);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  width: 100%;
  line-height: normal;
  border: none;
  margin-top: 16px;
  transition: all 0.3s ease-in-out;
}

.ButtonShowMonumenti:hover {
  background: var(--secondary);
}

.ExternalLinksTitle {
  color: var(--colori-neutri-dark-gray);
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
}

.BoxNoImages {
  height: 221px;
  padding: 0px 16px;
  margin-top: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid var(--overlay3);
  background: var(--colori-neutri-background);
  box-shadow: 2px 2px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--colori-neutri-gray);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.ExternalLink {
  display: flex;
  padding: 8px 8px 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  margin-top: 8px;
  color: var(--primary);
  text-align: center;
  /* Links */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
}

.ButtonUpload {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  margin-left: 8px;
  color: var(--colori-neutri-dark-gray);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.ButtonCancel {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--colori-neutri-gray-2);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--primary);
  border: none;
  margin-left: 8px;
  color: var(--primary);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.ButtonCaricaFoto {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  width: 100%;
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  margin-top: 16px;
  border: none;
  color: var(--colori-neutri-dark-gray);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.ButtonCaricaFoto:hover {
  background: var(--concorso-hover);
}

.NoMap {
  position: absolute;
  border-radius: 5px;
  background: rgba(178, 178, 178, 0.6);
  backdrop-filter: blur(1px);
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.NoCoordinatesTitle {
  color: var(--colori-neutri-white);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 8px;
}

.NoCoordinatesDescription {
  color: var(--colori-neutri-white);
  text-align: center;
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 8px;
}

.ComuneVedute {
  color: var(--colori-neutri-gray);
  text-overflow: ellipsis;
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.Close {
  margin-bottom: 16px;
  position: fixed;
  top: 90px;
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  z-index: 5;
}

.Close:hover,
.Close:active {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.BlockImageOverlay {
  border-radius: 0px 0px 5px 5px;
  background: linear-gradient(180deg, rgba(31, 30, 28, 0) 0%, #1f1e1c 60.42%);
  backdrop-filter: blur(1px);
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 58px;
  padding: 8px 16px;
}

.ResponseContainer {
  display: flex;
  width: 100%;
  height: 592px;
  padding: 16px 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 71px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--overlay);
}

.BlockImageOverlayTextArtist {
  color: var(--colori-neutri-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-right: 8px;
  border-right: 2px solid var(--colori-neutri-white);
  text-decoration: underline;
  cursor: pointer;
}

.BlockImageOverlayTextDate {
  color: var(--colori-neutri-white);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 2px;
  margin-left: 8px;
}

.CreditsImage {
  color: var(--colori-neutri-white);
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 2px;
  text-transform: uppercase;
}

.CurrentSlide {
  color: var(--primary);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.PaginationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.ButtonFixedCaricaFoto {
  display: none;
}

.ResponseOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
  padding: 24px 16px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.TextBeforeLogin {
  color: var(--primary);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.License {
  display: flex;
  align-items: center;
  color: var(--colori-neutri-dark-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ButtonAccetta {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  align-self: stretch;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  color: var(--colori-neutri-white, #fff);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.ButtonAccetta:hover {
  background: var(--concorso-hover);
}

.AdminBadge{
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  border: 1px solid var(--primary);
  color: var(--primary);
  text-align: center;
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  width: max-content;
  margin-top: 5px;
}

@media (min-width: 1024px) or ((hover: hover) and (pointer: fine)) {
  .BlockImage {
    border-radius: 5px;
    height: 270px;
    width: 100%;
    margin-top: 8px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }

  .PresenzaInConcorso {
    display: flex;
    padding: 5px;
    justify-content: center;
    align-items: center;
    gap: 9px;
    align-self: stretch;
    border-radius: 5px;
    border: 1px solid var(--concorso);
    background: var(--colori-neutri-white);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    font-family: var(--font-roboto-slab);
    color: var(--primary);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 50px;
  }

  .BlockImageRelevant {
    border-radius: 5px;
    height: 300px;
    width: 100%;
    margin-top: 8px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .ButtonFixedCaricaFoto {
    color: var(--colori-neutri-dark-gray, #fff);
    text-align: center;
    /* CTA */
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    padding: 4px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: var(--concorso);
    /* Shade Button Blu */
    box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
    position: fixed;
    border: none;
    right: 40px;
    top: 90px;
    width: max-content;
    z-index: 2;
    transition: all 0.3s ease-in-out;
  }

  .ButtonFixedCaricaFoto:hover {
    background: var(--concorso-hover);
  }

  .FixedButtonUpload {
    display: none;
  }

  .VeduteInsieme {
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    margin-top: 16px;
    border-radius: 10px;
    background: var(--overlay);
    /* Shade Button Light */
    box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  }

  .VeduteInsiemeTitle {
    color: var(--primary);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .VeduteInsiemeText {
    color: var(--primary);
    /* Body */
    font-family: var(--font-roboto-slab);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .Image {
    width: 80px;
    height: 80px;
    border-radius: 5px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }

  .ResponseContainer {
    display: flex;
    width: 629px;
    height: 592px;
    padding: 16px 64px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 71px;
    flex-shrink: 0;
    border-radius: 5px;
    background: var(--overlay);
  }
}
